<p class="mb-2">Загрузите csv файл с доступами от Инстатеки: </p>

@if (!load) {
  <button class="button" (click)="input.click()">Загрузить файл импорта</button>
}
@if (load) {
  <button class="button button_disabled" type="button">
    <i class="fa fa-spinner fa-spin mr-1"></i>
    Подождите, идёт обработка файла
  </button>
}

<div [hidden]="true" class="hidden">
  <input #input type="file" (change)="onFileChange($event)">
</div>

@if (!load) {
  <div class="row mt-4 mb-2" [formGroup]="form">
    <div class="col-6">
      Всего: <b>{{count}}</b>
    </div>
  </div>
  <div class="material-datatable-wrapper">
    <div class="table-responsive">
      <table class="table">
        <tr>
          @for (el of head; track el) {
            <th [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
              <div [formGroup]="form">
                <div class="row no-gutters align-items-center flex-nowrap" [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
                  <div class="col table__input">
                    @if (el.input) {
                      <app-material-input
                        [placeholder] = "el.caption"
                        [formControlName] = "el.name"
                        [cssClass]="'mb-0'">
                      </app-material-input>
                    }
                    @if (el.select) {
                      <app-material-select
                        [formControlName]="el.name"
                        [cssClass]="'mb-0'">
                        @for (opt of el.select; track opt) {
                          <option [value]="opt.id">{{opt.caption}}</option>
                        }
                      </app-material-select>
                    }
                    @if (!el.input && !el.select) {
                      {{el.caption}}
                    }
                  </div>
                  @if (el.sort) {
                    <div class="col-auto">
                      <a href="javascript:void(0)" (click)="sortChange(el.name)">
                  <i class="icon" [ngClass]="{'icon_new-sort-none': true == !sort[el.name],
                                      'icon_new-sort-down': 'asc' == sort[el.name],
                                      'icon_new-sort-up': 'desc' == sort[el.name]}"></i>
                      </a>
                    </div>
                  }
                </div>
              </div>
            </th>
          }
        </tr>
        <!-- // -->
        @for (row of rows; track row; let row_index = $index) {
          <tr>
            <td>
              <a [routerLink]="['/physical/edit/', row['physical_id'], 'common']">{{row['fio']}}</a>
            </td>
            <td>
              <a [routerLink]="['/entity/edit/', row['organisation_id'], 'common']">{{row['subagent_caption']}}</a>
            </td>
            <td>
              {{row['instateka_account']}}
            </td>
          </tr>
        }
      </table>
    </div>
  </div>
  <div class="alt-pagination">
    <app-paginator
      [queryParams]="filter_columns"
      [itemsPerPage]="50"
      [itemCount]="count"
      [currentPage]="current_page"
      [baseUrl]="'/instateka/users'">
    </app-paginator>
  </div>
}
